import {
  orgBrandingResponseSchema,
  type OrgBranding,
  type UpdateOrgBrandingRequest,
  type UpdateOrgLogoRequest,
} from '@emr/shared';

import { apiRequest } from './client.ts';

/**
 * Practice branding (`BACKLOG.md` B4) — validated against `@emr/shared`'s own response schema,
 * matching `api/auth.ts`'s own reasoning for why every client here goes through the shared schema
 * rather than a locally re-derived approximation of it.
 */

/** `GET /api/org/branding` — no capability gate; every signed-in member may read their own
 * practice's branding. */
export async function fetchOrgBranding(signal?: AbortSignal): Promise<OrgBranding> {
  const response = await apiRequest(
    '/api/org/branding',
    orgBrandingResponseSchema,
    signal === undefined ? {} : { signal },
  );
  return response.branding;
}

/** `PUT /api/org/branding` — colour and the user-override toggle. `org:manage_settings`. */
export async function updateOrgBranding(input: UpdateOrgBrandingRequest): Promise<OrgBranding> {
  const response = await apiRequest('/api/org/branding', orgBrandingResponseSchema, {
    method: 'PUT',
    body: input,
  });
  return response.branding;
}

/** `PUT /api/org/branding/logo` — `org:manage_settings` **and** the `whiteLabel` entitlement; a
 * 402 `not_entitled` `ApiError` on a lower tier is the caller's to interpret, matching
 * `api/platform.ts`'s own "not this function's job" precedent for a status-coded refusal. */
export async function updateOrgLogo(input: UpdateOrgLogoRequest): Promise<OrgBranding> {
  const response = await apiRequest('/api/org/branding/logo', orgBrandingResponseSchema, {
    method: 'PUT',
    body: input,
  });
  return response.branding;
}
